<template>
  <BaseSection>
    <div
      class="block-blog-articles-grid"
      :style="`--cols-number: repeat(${data.columns}, 1fr)`"
    >
      <template v-for="article in (pagedArticles as BlogCMSChildPage[])" :key="article.id">
        <NuxtLink :to="localePath(article?.meta?.url_path)" :title="article.title">
          <BlogArticleItem
            :title="article.title"
            :introduction="article.introduction"
            :image-src="article.image?.meta.download_url"
            :image-alt="article.image?.title"
            :created-at="article.meta.first_published_at"
          />
        </NuxtLink>
      </template>
    </div>
    <BlogPagination
      v-model:current-page="currentPage"
      class="mt-20"
      :per-page="data.itemsPerPage"
      :total-items="data.articles.length"
    />
  </BaseSection>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useLocalePath } from '#imports';
import BlogArticleItem from '~/components/blog/BlogArticleItem.vue';
import BaseSection from '~/components/BaseSection.vue';
import BlogPagination from '~/components/blog/BlogPagination.vue';
import type { BlogCMSChildPage } from '~/types';

interface Props {
  data: {
    articles: BlogCMSChildPage[]
    columns: number
    itemsPerPage: number
  }
}
const props = defineProps<Props>();
const localePath = useLocalePath();
const currentPage = ref(1);
const pagedArticles = computed(() => {
  const startIndex = (currentPage.value - 1) * props.data.itemsPerPage;
  const endIndex = startIndex + props.data.itemsPerPage;
  const articles = props.data.articles;
  if (!articles?.length) {
    return [];
  }

  return articles.slice(startIndex, endIndex);
});

</script>

<style scoped>
.block-blog-articles-grid {
  @apply grid grid-cols-1 gap-x-8 gap-y-20 lg:grid-cols-[var(--cols-number)];
}
</style>
